import { css } from '@emotion/react';

const sizeStyles = {
  xlarge: css`
    height: 64px;
    padding: 0px 40px;
    font-size: 18px;
  `,
  large: css`
    height: 48px;
    padding: 0px 32px;
    font-size: 16px;
  `,
  medium: css`
    height: 40px;
    padding: 0px 16px;
    font-size: 14px;
  `,
  small: css`
    height: 32px;
    padding: 0px 11px;
    font-size: 13px;
  `,
};

const colorStyles = {
  primary: css`
    color: white;
    background-color: var(--blue-400);
    &:hover {
      background-color: var(--blue-500);
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.3);
    }
    &:focus {
      background-color: var(--blue-500);
      box-shadow: 0 0 0 3px var(--blue-200);
    }
    &:disabled {
      background-color: var(--blue-200);
      pointer-events: none;
    }
  `,
  secondary: css`
    color: var(--blue-500);
    background-color: var(--blue-80);
    &:hover {
      background-color: var(--blue-100);
      box-shadow: 0 1px 3px 0 rgba(43, 150, 237, 0.2);
    }
    &:focus {
      box-shadow: 0 0 0 3px var(--blue-200);
    }
    &:disabled {
      opacity: 0.3;
      background-color: var(--blue-50);
      pointer-events: none;
    }
  `,
  gray: css`
    color: var(--gray-700);
    background-color: var(--gray-100);
    &:hover {
      background-color: var(--gray-200);
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
    }
    &:focus {
      box-shadow: 0 0 0 3px var(--gray-60);
    }
    &:disabled {
      opacity: 0.3;
      background-color: var(--gray-60);
      pointer-events: none;
    }
  `,
  outline: css`
    color: var(--gray-700);
    background-color: white;
    border: 1px solid var(--gray-300);
    &:hover {
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
    }
    &:focus {
      box-shadow: 0 0 0 3px var(--gray-80);
    }
    &:disabled {
      color: var(--gray-300);
      border: 1px solid var(--gray-100);
      pointer-events: none;
    }
  `,
};

export const container = (
  size: 'xlarge' | 'large' | 'medium' | 'small',
  color: 'primary' | 'secondary' | 'gray' | 'outline',
  full?: boolean
) =>
  css`
    display: flex;
    flex: 0 0 auto;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    text-align: center;
    border: 0;
    border-radius: 4px;
    font-weight: bold;
    letter-spacing: -0.2px;
    transition: all 0.3s ease;
    user-select: none;
    outline-style: none;
    cursor: pointer;
    ${sizeStyles[size]}
    ${colorStyles[color]}
    ${full && `width: 100%;`}
  `;

export const loading = css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const hiddenChildren = css`
  visibility: hidden;
`;

export const wrapper = css`
  position: relative;
  display: inline-flex;
`;

export const buttonContent = css`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const full = css`
  width: 100%;

  & > button {
    width: 100%;
    padding: 0px 8px;
  }
`;
